const developEndPoint = 'https://riskmm-nader93.fandogh.cloud';
export const SIDE_BAR_WIDTH = 340;
export const DASHBOARD_NAME = 'سامانه ارزیابی بلوغ مدیریت ریسک';
export const BaseUrl = developEndPoint;
export const ApiVersion = '';
export const banksName = [
  { value: 'BANK_MELLI', label: 'بانک ملی' },
  { value: 'BANK_MELLAT', label: 'بانک ملت' },
  { value: 'BANK_MASKAN', label: 'بانک مسکن' },
];
